import { useState, useCallback } from "react";

export type WorkspaceMember = {
  user_id: string;
  username: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  role: string;
  created_at: string;
};

interface WorkspaceMembersResponse {
  members: WorkspaceMember[];
}

export const useUserTable = () => {
  const [tableData, setTableData] = useState<WorkspaceMember[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchListData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch("/api/v1/workspace/members", {
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch members: ${response.status}`);
      }
      const data: WorkspaceMembersResponse = await response.json();
      setTableData(data.members || []);
    } catch (error) {
      console.error("Error fetching workspace members:", error);
      setTableData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    tableData,
    fetchListData,
  };
};
